import { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Outlet } from 'react-router-dom'

export const RequiredAuth: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth()
  const isAuthenticated = authState?.isAuthenticated

  useEffect(() => {
    const checkTokenValidity = async () => {
      if (!authState) return

      // Check authentication
      if (!isAuthenticated) {
        const originalUri = toRelativeUrl(window.location.href, window.location.origin)
        oktaAuth.setOriginalUri(originalUri)
        oktaAuth.signInWithRedirect()
        return
      }

      // Check token expiration and renew instead of signing out
      const accessToken = await oktaAuth.tokenManager.get('accessToken')
      if (
        !accessToken ||
        (accessToken.expiresAt && accessToken.expiresAt * 1000 < Date.now())
      ) {
        try {
          console.log('Token expired, attempting renewal...')
          await oktaAuth.tokenManager.renew('accessToken')
        } catch (error) {
          console.error('Token renewal failed, signing out:', error)
          oktaAuth.signOut()
        }
      }
    }

    checkTokenValidity()
  }, [oktaAuth, authState, isAuthenticated])

  return <Outlet />
}
